document.addEventListener('DOMContentLoaded', function () {
  // ============================================
  // 1. Checkbox Logic (Parent/Child Sync)
  // ============================================

  // Association Checkboxes (Parent)
  document.querySelectorAll('.association-check').forEach(parentCb => {
    parentCb.addEventListener('change', () => {
      const association = parentCb.dataset.association;
      const isChecked = parentCb.checked;

      // Select/Deselect all children
      const childCbs = document.querySelectorAll(`.filter-chip[data-association="${association}"] input[name="category"]`);
      childCbs.forEach(child => {
        child.checked = isChecked;
      });

      // Remove indeterminate state
      parentCb.closest('.filter-chip').classList.remove('is-indeterminate');

      applyFilters();
    });
  });

  // Category Checkboxes (Child)
  document.querySelectorAll('input[name="category"]').forEach(childCb => {
    childCb.addEventListener('change', () => {
      const association = childCb.closest('.filter-chip').dataset.association;
      updateAssociationState(association);
      applyFilters();
    });
  });

  // Update Parent State based on Children
  function updateAssociationState(association) {
    const parentCb = document.querySelector(`.association-check[data-association="${association}"]`);
    if (!parentCb) return;

    const parentChip = parentCb.closest('.filter-chip');
    const childCbs = document.querySelectorAll(`.filter-chip[data-association="${association}"] input[name="category"]`);
    const total = childCbs.length;
    const checked = Array.from(childCbs).filter(cb => cb.checked).length;

    if (checked === 0) {
      parentCb.checked = false;
      parentCb.indeterminate = false;
      parentChip.classList.remove('is-indeterminate');
    } else if (checked === total) {
      parentCb.checked = true;
      parentCb.indeterminate = false;
      parentChip.classList.remove('is-indeterminate');
    } else {
      parentCb.checked = false;
      parentCb.indeterminate = true;
      parentChip.classList.add('is-indeterminate');
    }
  }

  // Keyword Checkboxes
  document.querySelectorAll('input[name="keyword"]').forEach(cb => {
    cb.addEventListener('change', applyFilters);
  });

  // Toggle Filter Panel
  const filterToggle = document.querySelector('.filter-toggle');
  const filterPanel = document.getElementById('filter-panel');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const isExpanded = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', !isExpanded);
      filterPanel.hidden = isExpanded;
    });
  }

  // Clear Buttons (Sticky)
  const filterClearButtons = document.querySelectorAll('.filter-clear, .filter-clear--sticky');
  filterClearButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('#lesson-filters input[type="checkbox"]').forEach(cb => {
        cb.checked = false;
        cb.indeterminate = false;
      });
      document.querySelectorAll('.filter-chip.is-indeterminate').forEach(chip => {
        chip.classList.remove('is-indeterminate');
      });
      applyFilters();
    });
  });

  // ============================================
  // 2. Filtering Logic
  // ============================================
  function applyFilters() {
    // 1. Get Selected Criteria
    const selectedCategories = []; // Array of { association: 'ALA', category: 'basic' }
    document.querySelectorAll('input[name="category"]:checked').forEach(cb => {
      const association = cb.closest('.filter-chip').dataset.association;
      selectedCategories.push({
        association: association,
        category: cb.value
      });
    });

    const selectedKeywords = Array.from(document.querySelectorAll('input[name="keyword"]:checked')).map(cb => cb.value);

    // 2. Filter Cards
    const cards = document.querySelectorAll('.lesson-card');
    let totalVisible = 0;

    cards.forEach(card => {
      const cardAssociation = card.dataset.association;
      const cardCategory = card.dataset.category;
      const cardKeywords = (card.dataset.keywords || '').split(',');

      // Category Match (OR Logic)
      // If no categories selected, show all (implicit).
      // If categories selected, card must match one of the selected (Assoc + Cat pair).
      let isCategoryMatch = true;
      if (selectedCategories.length > 0) {
        isCategoryMatch = selectedCategories.some(sel =>
          sel.association === cardAssociation && sel.category === cardCategory
        );
      }

      // Keyword Match (AND Logic)
      // If no keywords selected, show all.
      // If keywords selected, card must contain ALL selected keywords.
      let isKeywordMatch = true;
      if (selectedKeywords.length > 0) {
        isKeywordMatch = selectedKeywords.every(kw => cardKeywords.includes(kw));
      }

      const isVisible = isCategoryMatch && isKeywordMatch;
      card.style.display = isVisible ? '' : 'none';
      if (isVisible) totalVisible++;

      // Highlight Keywords
      highlightKeywords(card, selectedKeywords);
    });

    // 3. Update Section Visibility
    updateSectionVisibility();

    // 4. Update Result Count & Sticky Bar
    const resultNumber = document.querySelector('.result-number');
    if (resultNumber) resultNumber.textContent = totalVisible;

    const hasActiveFilters = selectedCategories.length > 0 || selectedKeywords.length > 0;
    const filterStatus = document.querySelector('.filter-status');
    if (filterStatus) {
      filterStatus.style.display = hasActiveFilters ? 'flex' : 'none';
      if (hasActiveFilters) adjustFilterStatusPosition();
    }
  }

  function updateSectionVisibility() {
    // Hide empty Category Groups
    document.querySelectorAll('.lesson-category-group').forEach(group => {
      const visibleCards = group.querySelectorAll('.lesson-card:not([style*="display: none"])');
      group.style.display = visibleCards.length > 0 ? '' : 'none';
    });

    // Hide empty Association Groups
    document.querySelectorAll('.lesson-association-group').forEach(group => {
      // Check if any child category group is visible
      const visibleCatGroups = group.querySelectorAll('.lesson-category-group:not([style*="display: none"])');
      group.style.display = visibleCatGroups.length > 0 ? '' : 'none';
    });
  }

  function highlightKeywords(card, selectedKeywords) {
    const tags = card.querySelectorAll('.keyword-tag');
    tags.forEach(tag => {
      const text = tag.textContent.replace('#', ''); // Remove # for matching
      // If text matches ANY selected keyword, bold it.
      // Wait, user said "Keyword search is AND", but highlighting usually highlights any matched keyword.
      // If I search "Cookie" AND "Beginner", I should highlight both "Cookie" and "Beginner" tags.
      if (selectedKeywords.includes(text)) {
        tag.classList.add('is-active');
      } else {
        tag.classList.remove('is-active');
      }
    });
  }

  // ============================================
  // 3. Sticky Status Position
  // ============================================
  function adjustFilterStatusPosition() {
    const filterStatus = document.querySelector('.filter-status');
    if (!filterStatus || filterStatus.style.display === 'none') return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // Adjust logic based on header height (assuming similar to salonlist)
    if (scrollTop < 100) {
      filterStatus.style.top = window.innerWidth <= 768 ? '160px' : '160px';
    } else {
      filterStatus.style.top = window.innerWidth <= 768 ? '90px' : '100px';
    }
  }

  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) window.cancelAnimationFrame(scrollTimeout);
    scrollTimeout = window.requestAnimationFrame(adjustFilterStatusPosition);
  }, { passive: true });

  window.addEventListener('resize', adjustFilterStatusPosition);

  // Handle Back-Forward Cache (bfcache) and initial load
  window.addEventListener('pageshow', function (event) {
    // Re-apply filters whenever the page is shown (load or back/forward)
    applyFilters();
  });

  // Initial call (just in case pageshow doesn't fire on some browsers on initial load, though it usually does)
  applyFilters();
});
